<template>
  <div class="page">
    <NavBar />
    <!-- Route to meeting creation page \create-meeting -->
    <!-- <router-link to="/create-meeting"> -->
    <!-- 3 column, profile, meetings, upcoming meeting -->
    <div class="flex-container">
      <div id="column1">
        <div class="profile">
          <div class="profile-header">
            <img id="profile-pic" src="./../assets/images/profile-pic.svg">
            <h3> {{ user.fullName }}</h3>
            <!-- display stars-outline.svg -->
            <img src="./../assets/images/stars-outline.svg">
            <!-- grey small font p -->
            <p style="font: 0.8em sans-serif; color: grey;"> 0 reviews</p>
            <div id="icon-container">
              <img src="./../assets/images/location-icon.svg">
              <p> Los Angeles, CA </p>
            </div>
            <div id="icon-container">
              <img src="./../assets/images/phone-icon.svg">
              <p> (123) 456-7890 </p>
            </div>
            <div id="icon-container">
              <img src="./../assets/images/email-icon.svg">
              <p> maks@gmail.com </p>
            </div>
            <div id="icon-container">
              <img src="./../assets/images/education-icon.svg">
              <p> University of Southern California </p>
            </div>
            <div id="icon-container">
              <img src="./../assets/images/bio-icon.svg">
              <!-- small bio about counselor -->
              <p> <strong>Bio :</strong> I am a counselor with 10 years of experience. I specialize in college admissions and
                standardized testing. </p>
            </div>
            <div>
              <SearchTag name="Standardized Tests" style="margin-right: 5px; margin-bottom: 0px;"/>
              <SearchTag name="College Admissions" style="margin-right: 5px; margin-bottom: 0px;"/>
              <SearchTag name="SAT" style="margin-right: 5px; margin-bottom: 0px;"/>
              <SearchTag name="ACT" style="margin-right: 5px; margin-bottom: 0px;"/>
            </div>
            <!-- Link to edit profile -->
            <p style="color: blue;"> + Edit Profile </p>
          </div>
        </div>
      </div>
      <div id="column2">
        <div class="my-schedule">
          <div id="schedule-nav">
            <div id="tabs">
              <button id="upcoming-tab" @click="() => toggleTab(true)"> Upcoming </button>
              <button id="all-tab" @click="() => toggleTab(false)"> All </button>
            </div>
            <div>
              <p id="month"> April 2023 </p>
            </div>
            <div>
              <router-link :to="{name: 'create-meeting', params:{counselor_user_id: `${user_id}`, counselor_name: `${name}` }}">
                  <div id="add-meeting" class="btn-blue" style="text-decoration: none;"> Add Meeting </div>
              </router-link>
            </div>
          </div>
          <h3> Scheduled Meetings </h3>
          <div class="calendar">
            <template v-if="meetings.length > 0">
                <!-- Render meetings from array -->
                <table>
                    <tr>
                      <th> Name </th>
                      <!-- add space -->
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Date </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Time </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Topic </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Link to Meeting</th>
                      
                    </tr>
                </table>
                    <hr style="width: 100%; margin-bottom: 16px;"/>
                <table>
                <template v-for="meeting in meetings" :key="meeting.id">
                  
                    <tr>
                  <td style="font-size: 0.8em; padding: 10px;"> {{ meeting.counselor_name }} </td>
                  <td style="font-size: 0.8em;padding: 10px;"> {{ meeting.meeting_date }} </td>
                  <!-- Add meeting_length to meeting time so it looks like something like 3:00-3:30 -->
                  <td style="font-size: 0.8em;padding: 10px;"> {{ getMeetingTimeString(meeting) }} </td>
                  <td style="font-size: 0.8em;padding: 10px;"> {{ meeting.meeting_topic }} </td>
                  <td> <SearchTag name="Link to Meeting Details" style="margin-right: 5px; margin-bottom: 0px;"/> </td>
                </tr>
                </template>
                  </table>

              </template>
              <template v-else>
                <img src="./../assets/images/color-calendar.svg">
                <p id="no-meetings"> No Scheduled Meetings </p>
              </template>
          </div>
          <h3> Meeting Requests </h3>
          <div class="calendar">
            
            <template v-if="meeting_requests.length > 0">
                <!-- Render meetings from array -->
                <br><br><br><br><br><br><br><br><br><br><br><br>
                <table>
                    <tr>
                      <th> Name </th>
                      <!-- add space -->
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Date </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Time </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Topic </th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th> Link to Meeting</th>
                      
                    </tr>
                </table>
                    <hr style="width: 100%; margin-bottom: 16px;"/>
                <table>
                <template v-for="meeting in meeting_requests" :key="meeting.id">
                  
                    <tr>
                  <td style="font-size: 0.8em; padding: 10px;"> {{ meeting.counselor_name }} </td>
                  <td style="font-size: 0.8em;padding: 10px;"> {{ meeting.meeting_date }} </td>
                  <!-- Add meeting_length to meeting time so it looks like something like 3:00-3:30 -->
                  <td style="font-size: 0.8em;padding: 10px;"> {{ getMeetingTimeString(meeting) }} </td>
                  <td style="font-size: 0.8em;padding: 10px;"> {{ meeting.meeting_topic }} </td>
                  <td>
                    <!-- If meeting.accepted == pending -->
                    <template v-if="meeting.accepted == 'pending'">
                      <p style="color: orange;"> Pending Approval </p>
                    </template>
                    <template v-else>
                      <p style="color: red;"> Declined </p>
                    </template>
                  </td>
                </tr>
                </template>
                  </table>

              </template>
              <template v-else>
                <img src="./../assets/images/color-calendar.svg">
                <p id="no-meetings"> No Scheduled Meetings </p>
              </template>
          </div>
        </div>
      </div>
      <div id="column3">
          
          <div class="upcoming-meeting">
            <h3> Upcoming Meeting </h3>
            <hr style="width: 100%; margin-bottom: 16px;"/>
              <template v-if="meetings.length > 0">
                <!-- Render first meeting from array -->
                <p> <strong> {{ meetings[0].counselor_name }} </strong> </p>
                <p> {{ meetings[0].meeting_date }} </p>
                <p> {{ getMeetingTimeString(meetings[0]) }} </p>
                <p> <strong>Topic: </strong>{{ meetings[0].meeting_topic }} </p>
                <SearchTag name="Link to Meeting Details" style="margin-right: 5px; margin-bottom: 0px;"/>
              </template>
              <template v-else>
                <p> <strong> No Meetings</strong> </p>
              </template>
          </div>
      </div>
    </div>
  </div>

</template>
<script>
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';
import axios from 'axios'; // Make sure to install axios if not already done
// import VueCal from 'vue-cal'
// import 'vue-cal/dist/vuecal.css'
import NavBar from './../components/NavBar.vue'
import SearchTag from './../components/SearchTag.vue'
import Auth from '../auth/auth.js'
// import router from '@/router';

export default {
  props: ['all'],
  components: {
    // VueCal,
    NavBar,
    SearchTag
  },
  data() {
    return {
      type: "upcoming",
      meetings: [], // Initialize meetings array to store fetched meetings
      meeting_requests: [], // Initialize meeting requests array to store fetched meeting requests,
      // Initialize user object to store fetched user data, nothing in it yet
      user: {
        fullName: "",
        email: "",
        phone: "",
        university: "",
        bio: "",
        location: "",
      }
    };
  },
  mounted() {
    this.fetchMeetings();
    this.fetchMeetingRequests();
    this.fetchFullName();
    console.log("Meetings:", this.meetings);

  },
  methods: {
    fetchMeetings() {
      // Replace 'your_api_endpoint' with the actual endpoint from which to fetch meetings
      axios.get(`${API_BASE}/get_user_schedule?student_user_id=${Auth.getUserID()}`)
        .then(response => {
          this.meetings = response.data.meetings; // Assuming the API returns an array of meetings
          console.log("Meetings:", this.meetings);
        })
        .catch(error => {
          console.error("There was an error fetching the meetings:", error);
        });
    },
    fetchFullName() {
      // Replace 'USER_ID' with the actual user ID you wish to query
      const userId = Auth.getUserID(); // Assuming getCookie method exists to fetch user_id from cookies
      if (!userId) {
        console.error("User ID not found in cookies");
        return;
      }
      fetch(`${API_BASE}/get-user?id=${userId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Assuming the API returns an object with first_name and last_name properties
          console.log(data);
          this.user.fullName = `${data.user.first_name} ${data.user.last_name}`;
        })
        .catch(error => console.error("Failed to fetch user data:", error));
    },
    
    fetchMeetingRequests() {
      // Replace 'your_api_endpoint' with the actual endpoint from which to fetch meetings
      axios.get(`${API_BASE}/get_user_meeting_requests?student_user_id=${Auth.getUserID()}`)
        .then(response => {
          this.meeting_requests = response.data.meetings; // Assuming the API returns an array of meetings
          console.log("Meetings:", this.meetings);
        })
        .catch(error => {
          console.error("There was an error fetching the meetings:", error);
        });
    },
    toggleTab(upcoming) {
      if (!upcoming) { // switch to all
        this.type = 'all';
        document.getElementById("upcoming-tab").style.borderBottom = "none";
        document.getElementById("all-tab").style.borderBottom = "3px solid #FFD966"
      } else { // switch to upcoming
        this.type = 'upcoming';
        document.getElementById("all-tab").style.borderBottom = "none";
        document.getElementById("upcoming-tab").style.borderBottom = "3px solid #FFD966"
      }
    },
    addMeeting() {
      console.log("Add Meeting");
      // TODO: Implement
      document.getElementById("meeting-modal").style.display = "flex";
      // document.getElementById("overlay").style.display = "block";
    },
    getMeetingTimeString(meeting) {
      // Add meeting_length to meeting time so it looks like something like 3:00-3:30
      //Get the start time string (formatted as HH:MM:SS)
      let startTime = `1970-01-01T${meeting.meeting_time}`;
      //Convert the start time string to a Date object
      let startDate = new Date(startTime);
      //Get the end time, given that the meeting length is an integer representing the number of minutes
      let endTime = new Date(startDate.getTime() + meeting.meeting_length * 60000);
      //Format the start and end times as strings
      let startTimeString = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      let endTimeString = endTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      //Return the formatted time string
      return `${startTimeString}-${endTimeString}`;
    },
    closeModal() {
      document.getElementById("meeting-modal").style.display = "none";
      // document.getElementById("overlay").style.display = "none";
    }
    
  }
}
</script>

<style>
.flex {
  display: flex;
  align-items: baseline;
  justify-content: bottom;
}

.my-schedule {
  /* width: 80%; */
  /* max-width: 1000px; */
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
}

.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.profile {
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;
  border-radius: 12px;
  padding: 16px;
  margin: 16px;
}
.profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.profile-header #profile-pic{
  width: 75px;
  height: 75px;
  border-radius: 50px;
}

.profile-header #icon-container{
  display: flex;
  flex-direction: row;
  justify-content: left;
  width: 100%;
  margin-top: 8px;
}

.profile-header #icon-container img{
  width: 20px;
  height: 20px;
}

.profile-header #icon-container p{
  font-size: 0.8em;
  margin: 0px;
  margin-left: 3px;
  color: grey;
}

.upcoming-meeting {
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: white;
  align-items: center;
  border-radius: 12px;
  padding: 16px;
  margin: 16px;
}

#column1 {
  display: flex;
  align-items: flex-start; 
  height: 100vh;
  flex: 0.8;
}

#column2 {
  flex: 1.8;
}

#column3 {
  display: flex;
  align-items: flex-start; 
  height: 100vh;
  flex: 0.6;
}

select {
  height: 4.5vh;
  border-radius: 0.5em;
  border-color: gray;
  color: gray;
}

#overlay {
  width: 100%;
  height: 100vh;
  background-color: green;
  opacity: 0.01;
  display: none;
}

#modal-header {
  background-color: #3867AE;
  color: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-around;

  width: 100%;
}

#meeting-modal {
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 12px;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  max-width: 500px;
  padding-bottom: 16px;
}

#modal-close {
  font-family: 'Axiforma-Regular';
  src: url('~@/assets/fonts/Axiforma-Regular.ttf');
  background: none;
  border: none;
  width: fit-content;
  text-transform: uppercase;
  color: white;
  font-weight: 700;
}

#meeting-modal>* {
  margin-bottom: 8px;
}

#tabs {
  width: 30%;
  display: flex;
  width: fit-content;
}

#tabs button {
  font-family: 'Axiforma-Regular';
  src: url('~@/assets/fonts/Axiforma-Regular.ttf');
  background: none;
  border: none;
  width: fit-content;
  text-transform: uppercase;
  color: #3867AE;
  font-weight: 700;
}

#upcoming-tab {
  border-bottom: 3px solid #FFD966;
}

.btn-blue {
  font-family: 'Axiforma-Regular';
  src: url('~@/assets/fonts/Axiforma-Regular.ttf');
  background: none;
  border: none;
  width: fit-content;
  background-color: #3867AE;
  color: white;
  padding: 8px 16px;
  font-weight: 700;
  border-radius: 20px;
}

#request-meeting {
  height: fit-content;
  bottom: 0px;
}

#schedule-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* border: 1px dotted red; */
  color: #3867AE;
  font-weight: 700;
}

.calendar {
  background-color: white;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding: 48px;
  max-height: 250px;
}
</style>